/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router';

import Barcode from './views/barcode.vue'
import InstallmentsReport from './views/InstallmentsReport.vue'

import Dashboard from "./views/Dashboard.vue";
import NewSale from "./views/Sales/Index.vue";
import FaturaInvoice from "./views/Sales/Fatura.vue";
import EditSale from "./views/Sales/Edit.vue";
import Sales from "./views/Sales/Report.vue";
import DeletedSales from "./views/Sales/Deleted.vue";
import Login from "./views/Auth/Login.vue";
import NewCustomer from "./views/Customers/New.vue";
import CustomerPayment from "./views/Customers/Payment.vue";
import CustomerReport from "./views/Customers/Report.vue";
// import CustomerReportCopy from "../views/Customers/ReportCopy.vue";
import CustomerReoprtAll from "./views/Customers/ReportAll.vue";
import SupplierPayment from "./views/Suppliers/Payment.vue";
import NewSupplier from "./views/Suppliers/New.vue";
import SupplierReport from "./views/Suppliers/Report.vue";
// import SupplierReportCopy from "../views/Suppliers/ReportCopy.vue";
import SupplierReportAll from "./views/Suppliers/ReportAll.vue";
import NewSafeOperation from "./views/Safe/Operation.vue";
import SafeReport from "./views/Safe/Report.vue";
import SafeTaslim from "./views/Safe/Taslim.vue";
import TaslimReport from "./views/Safe/TaslimReport.vue";
// import Customers from "../views/Customers/Index.vue";
import NewProduct from "./views/Products/New.vue";
import ProductsReport from "./views/Products/Index.vue";
import ProductsStock from "./views/Products/Stock.vue";
import OutStockProducts from "./views/Products/OutStock.vue";
import ProductsMovementReport from "./views/Products/Report.vue";
import ProductsCategory from "./views/Products/Categories.vue";
// import ReturnSale from "../views/Sales/Return.vue";
import SalesProfites from "./views/Sales/Profites.vue";
import NewPurchase from "./views/Purchases/Index.vue";
import EditPurchase from "./views/Purchases/Edit.vue";
import Purchases from "./views/Purchases/Report.vue";
import ReturnPurchaseProduct from "./views/Purchases/ReturnProduct.vue";
import ReturnPurchaseInvice from "./views/Purchases/ReturnInvice.vue";
import DeletedPurchases from "./views/Purchases/Deleted.vue";
// import ReturnPurchase from "../views/Purchases/Return.vue";
import ExpensesReport from "./views/Expenses/Report.vue";
import ExpensesReportDetails from "./views/Expenses/ReportDetails.vue";
import NewExpense from "./views/Expenses/New.vue";
import ExpensesCategories from "./views/Expenses/Categories.vue";
// import Home from "../views/Home"
import Notebook from "./views/Pay/Notebook"
import Suppliers from "./views/Pay/Suppliers"
import Customer from "./views/Pay/Customers.vue"
import Settings from "./views/Settings.vue";
import DamagedProducts from "./views/Products/DamagedProducts.vue";
import DamagedProductReport from "./views/Products/DamagedProductsReport.vue";
import AllUsers from "./views/Users/AllUsers.vue";
import NewUser from "./views/Users/NewUser.vue";
import ReturnedReport from "./views/Sales/ReturnedReport.vue";
import ReturnedPurchases from "./views/Purchases/ReturnedReport.vue";
import ReturnProduct from "./views/Sales/ReturnProduct.vue";
import ReturnInvice from "./views/Sales/ReturnInvice.vue";
import Logs from "./views/Users/Logs.vue";
import Jobs from "./views/Users/Jobs.vue";
import FaturaEdit from "./views/Sales/FaturaEdit.vue";
import FaturaReturn from "./views/Sales/FaturaReturn.vue";
import Projects from "./views/Projects/index.vue";
import Investments from "./views/Investments/index.vue";
import InvestmentLogs from "./views/Investments/logs.vue";
import Cities from "./views/Cities/index.vue";
import Locations from "./views/Locations/index.vue";
import projectUnits from "./views/Projects/units.vue";
import projectUnit from "./views/Product_units/index.vue";
import Clients from "./views/Clients/index.vue";
import JobsTypes from "./views/Jobs/index.vue";
import Workers from "./views/Workers/index.vue";
import Borrowers from "./views/Borrowers/index.vue";
import Parteners from "@/views/Parteners/index.vue";
import Partener from "@/views/Parteners/payment.vue";


import SingleWorker from "./views/Workers/SingleWorker.vue";
import SingleBorrower from "./views/Borrowers/SingleBorrower.vue";


Vue.use(Router)

const router = new Router({

  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [

    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'home',
          component: () => import('./views/Home.vue')
        },
        {
          path: '/page2',
          name: 'page-2',
          component: () => import('./views/Page2.vue')
        },

        // *********************************************** Start Routers ************************************************
        {
          path: "/",
          name: "NewSale",
          meta: {
            requiresAuth: true
          },
          component: NewSale,
        },
        {
          path: "/dashboard",
          name: "Dashboard",
          component: Dashboard,
        },

        {
          path: "/customers/payment",
          name: "CustomerPayment",
          component: CustomerPayment,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/customers/report",
          name: "CustomerReport",
          component: CustomerReport,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/customers/report-all",
          name: "CustomerReportAll",
          component: CustomerReoprtAll,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/customers/new",
          name: "NewCustomer",
          component: NewCustomer,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/suppliers/payment",
          name: "SupplierPayment",
          component: SupplierPayment,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/suppliers/new",
          name: "NewSupplier",
          component: NewSupplier,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/suppliers/report",
          name: "SupplierReport",
          component: SupplierReport,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/suppliers/report-all",
          name: "SupplierReportAll",
          component: SupplierReportAll,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/safe/operation",
          name: "NewSafeOperation",
          component: NewSafeOperation,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/safe/report",
          name: "SafeReport",
          component: SafeReport,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/safe/taslim",
          name: "SafeTaslim",
          component: SafeTaslim,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/taslim/report",
          name: "TaslimReport",
          component: TaslimReport,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/expenses/new",
          name: "NewExpense",
          component: NewExpense,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/expenses/report",
          name: "ExpensesReport",
          component: ExpensesReport,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/expenses/details",
          name: "ExpensesReportDetails",
          component: ExpensesReportDetails,
          meta: {
            requiresAuth: true
          },
        },
        
        {
          path: "/installments-report",
          name: "installmentsReport",
          component: InstallmentsReport,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/expenses/categories",
          name: "ExpensesCategories",
          component: ExpensesCategories,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/sales/report",
          name: "Sales",
          component: Sales,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/sales/returned-sales",
          name: "ReturnedSales",
          component: ReturnedReport,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/sales/deleted",
          name: "DeletedSales",
          component: DeletedSales,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/sales",
          name: "NewSale",
          component: NewSale,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/sales/fatura",
          name: "FaturaInvoice",
          component: FaturaInvoice,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/sales/edit/:id",
          name: "EditSale",
          component: EditSale,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/sales/fatura-edit/:id",
          name: "FaturaEdit",
          component: FaturaEdit,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/sales/edit/:id",
          name: "EditSale",
          component: EditSale,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/products",
          name: "ProductsReport",
          component: ProductsReport,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/products/stock",
          name: "ProductsStock",
          component: ProductsStock,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/products/to-order",
          name: "OutStockProducts",
          component: OutStockProducts,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/products/report",
          name: "ProductsMovementReport",
          component: ProductsMovementReport,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/products/new",
          name: "NewProduct",
          component: NewProduct,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/products/category",
          name: "ProductsCategory",
          component: ProductsCategory,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/products/damaged",
          name: "DamagedProducts",
          component: DamagedProducts,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/products/damaged-report",
          name: "DamagedProductReport",
          component: DamagedProductReport,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/sales/return",
          name: "ReturnSale",
          component: ReturnProduct,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/sales/return/:id",
          name: "ReturnProduct",
          component: ReturnInvice,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/sales/fatura-return/:id",
          name: "FaturaReturn",
          component: FaturaReturn,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/sales/profites",
          name: "SalesProfites",
          component: SalesProfites,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/purchases",
          name: "NewPurchase",
          component: NewPurchase,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/purchases/edit/:id",
          name: "EditPurchase",
          component: EditPurchase,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/purchases/report",
          name: "Purchases",
          component: Purchases,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/purchases/returned-purchases",
          name: "ReturnedPurchases",
          component: ReturnedPurchases,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/purchases/return",
          name: "ReturnPurchase",
          component: ReturnPurchaseProduct,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/purchases/return/:id",
          name: "ReturnPurchase",
          component: ReturnPurchaseInvice,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/purchases/deleted",
          name: "DeletedPurchases",
          component: DeletedPurchases,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/pay/notebook",
          name: "Notebook",
          component: Notebook,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/pay/suppliers",
          name: "Suppliers",
          component: Suppliers,
          meta: {
            requiresAuth: true
          },
        },

        {
          path: "/pay/customer",
          name: "Customer",
          component: Customer,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "/settings",
          name: "Settings",
          component: Settings,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/users/all-users",
          name: "AllUsers",
          component: AllUsers,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/users/new-user",
          name: "NewUser",
          component: NewUser,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/users/logs",
          name: "UsersLogs",
          component: Logs,
          meta: {
            requiresAuth: true
          }
        },

        {
          path: "/projects",
          name: "Projects",
          component: Projects,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/projects/:id",
          name: "ProjectsUnits",
          component: projectUnits,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/investments",
          name: "Investments",
          component: Investments,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/investments/:id",
          name: "InvestmentLogs",
          component: InvestmentLogs,
          meta: {
            requiresAuth: true
          }
        },


        {
          path: "/project_units/:id",
          name: "ProjectsUnit",
          component: projectUnit,
          meta: {
            requiresAuth: true
          }
        },


        {
          path: "/cities",
          name: "Cities",
          component: Cities,
          meta: {
            requiresAuth: true
          }
        },

        {
          path: "/clients",
          name: "clients",
          component: Clients,
          meta: {
            requiresAuth: true
          }
        },


        {
          path: "/locations",
          name: "Locations",
          component: Locations,
          meta: {
            requiresAuth: true
          }
        },


        {
          path: "/jobs",
          name: "jobs",
          component: JobsTypes,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/workers",
          name: "Workers",
          component: Workers,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/worker/:id",
          name: "SingleWorker",
          component: SingleWorker,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/borrowers",
          name: "Borrowers",
          component: Borrowers,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/borrower/:id",
          name: "SingleBorrower",
          component: SingleBorrower,
          meta: {
            requiresAuth: true
          }
        },


        {
          path: "/users/jobs",
          name: "UsersJobs",
          component: Jobs,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/barcode",
          name: "barcode",
          component: Barcode,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/parteners',
          name: "parteners",
          component: Parteners,
          meta: {
            requiresAuth: true
          }
        },

        {
          path: '/parteners/:id',
          name: "partener",
          component: Partener,
          meta: {
            requiresAuth: true
          }
        }
        // ************************************************ End Routers ************************************************


      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue')
        },
        {
          path: "/login",
          name: "Login",
          component: Login,
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        },
        {
          path: '/printing',
          name: 'printing',
          component: require('./components/Printing.vue').default,
        },
        {
          path: '/print_worker_deals',
          name: 'print_worker_deals',
          component: require('./components/print_worker_deals.vue').default,
        },


      ]
    },








    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})

export default router
